import { Button } from '@mui/material';
import { parseISO, isValid, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { slotFinder } from '../utils/slotFinder';

const AvailabilityButton = ({
  masseuse,
  slots,
  available_on,
  buttonSize = 'large',
  marginTop = 4,
  marginBottom = 0,
}) => {
  const foundSlots = slotFinder(masseuse.id, slots)?.start_time;
  const time = foundSlots ? parseISO(foundSlots) : false;
  const displayTime =
    time && isValid(time) ? toZonedTime(time, 'America/Toronto') : false;

  if (available_on !== 'today') {
    return null;
  }

  return displayTime !== false ? (
    <Button
      variant="contained"
      sx={{
        pointerEvents: 'none',
        mt: marginTop,
        mb: marginBottom,
      }}
      size={buttonSize}
      disableElevation
      fullWidth={false}
      color="secondary"
    >
      next available today at&nbsp;
      <span
        style={{
          fontWeight: 'bold',
        }}
      >
        {format(displayTime, 'h:mm a')}
      </span>
    </Button>
  ) : (
    <Button
      variant="contained"
      sx={{
        mt: marginTop,
        pointerEvents: 'none',
        mb: marginBottom,
      }}
      size={buttonSize}
      color="secondary"
      disabled
      disableElevation
    >
      Fully Booked for Today
    </Button>
  );
};

export default AvailabilityButton;
